import { TablePaginationConfig, Modal } from "antd";
import { SorterResult } from "antd/lib/table/interface";
import { EnrollmentFormModel } from "models/EnrollmentForm";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { EnrollmentFormServiceInstance } from "services/enrollmentFormService";

import { EnrollmentFormsGeneratedProps } from "./EnrollmentForms.props";
import EnrollmentFormsView from "./EnrollmentForms.view";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";
import {AllErrors, NotFoundError} from "types/Errors";

const EnrollmentForms = (): JSX.Element => {
  // MARK:- Hooks
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // MARK:- Query
  const enrollmentFormListQuery = useQuery(
    "enrollmentForm",
    EnrollmentFormServiceInstance.getList,
    {
      onSuccess: (data) => {
        console.log('success fetching enrollment forms', data);
      },
      onError: (err) => {
        console.error('fail fetching enrollment forms', err);
      },
    }
  );

  const enrollmentFormDeleteMutation = useMutation(
    (data: EnrollmentFormModel) => EnrollmentFormServiceInstance.delete(data.id as string),
    {
      onSuccess: () => {
        navigate("");
        navigate("/dashboard/enrollment-forms");
      },
      onError: (error: AllErrors) => {
        if (error instanceof NotFoundError) {
          navigate("/not-found");
          return;
        }
      },
    }
  );

  const archiveEnrollmentFormMutation = useMutation(
    (data: EnrollmentFormModel) => EnrollmentFormServiceInstance.archive(data.id as string),
    {
      onSuccess: () => {
        navigate("/dashboard/enrollment-forms");
      },
      onError: (error: AllErrors) => {
        if (error instanceof NotFoundError) {
          navigate("/not-found");
          return;
        }
      },
    }
  );

  // MARK:- Functions
  function onClickCreate() {
    navigate("/dashboard/enrollment-forms/create");
  }

  function onClickSendEnrollmentForm() {
    navigate("/dashboard/enrollment-forms/invite");
  }

  function onChange(
    pagination: TablePaginationConfig,
    filters: Record<string, (string | number | boolean)[] | null>,
    sorter: SorterResult<EnrollmentFormModel> | any
  ) {
    console.log("params", pagination, filters, sorter);
  }

  function onClickViewDiagnostic(id: string) {
    queryClient.invalidateQueries("survey");
    queryClient.invalidateQueries("surveyAnswers");
    queryClient.invalidateQueries("enrollmentForms");
    queryClient.invalidateQueries("ceoSubmittedForm");

    navigate(`/dashboard/diagnostic/${id}`);
  }

  function onClickEditEnrollmentForm(enrollmentFormId: string) {
    window.open(`/answer-enrollmentForm/${enrollmentFormId}`);
  }

  function onClickEditSurveyForm(enrollmentFormId: string) {
    window.open(`/answer-ceoSurvey/${enrollmentFormId}`);
  }

  console.log('should load enrollment forms');
  return (<>
    <EnrollmentFormsView
      onChange={onChange}
      onClickCreate={onClickCreate}
      onClickSendEnrollmentForm={onClickSendEnrollmentForm}
      onClickViewDiagnostic={onClickViewDiagnostic}
      onClickEditEnrollmentForm={onClickEditEnrollmentForm}
      onClickEditSurveyForm={onClickEditSurveyForm}
      onClickArchiveRecord={(data: EnrollmentFormModel) => {
        Modal.confirm({
          title: "Do you want to archive this record?",
          icon: <ExclamationCircleOutlined />,
          content: "",
          onOk() {
            console.log('Pre-data ', JSON.stringify(data));
            archiveEnrollmentFormMutation.mutate(data);
          },
        });
      }}
      onClickDeleteRecord={(data: EnrollmentFormModel) => {
        Modal.confirm({
          title: "Do you want to delete this record?",
          icon: <ExclamationCircleOutlined />,
          content: "",
          onOk() {
            enrollmentFormDeleteMutation.mutate(data);
          },
        });
      }}
      data={enrollmentFormListQuery.data?.body || []}
      loading={enrollmentFormListQuery.isLoading}
    />
  </>);
};

export default EnrollmentForms;

